/* eslint-disable */
import React from 'react';
import { createRoot } from 'react-dom/client';

import 'scorm-again';
import '@shared/services/i18n';

import Root from '@/pages/Root';

import 'video-react/dist/video-react.css';
import '@shared/styles/month-picker.css';
import '@/styles/index.css';
import '@shared/styles/style.css';
import '@shared/services/init-dayjs';
import '@sharedPartner/fonts/index.scss';
import '@ant-design/v5-patch-for-react-19'; // Для корректной работы АнтД в 19 версии реакта

const container = document.getElementById('root');
if (!container) throw new Error('Root container not found');

const root = createRoot(container);

root.render(<Root />);
